import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  partners1,
  partners2,
  partners3,
  partners4,
  partners5,
  partners6,
  partners7,
  partners8,
  partners9,
  partners10,
  partners11,
  partners12,
  partners13,
  partners14,
  partners15,
  partners16,
  partners17,
  partners18,
  partners19,
  partners20,
  partners21,
  partners22,
} from "../../../assets/images";
import "./Partners.css";
import axios from "axios";

const Brands = () => {
  const { t } = useTranslation();
  const marqueeRef = useRef(null);
  const [partners, setPartners] = useState([])

  
      useEffect(() => {
                getProducts();
              }, []);
            
              const getProducts = async () => {
                try {
                  const response = await axios.get(
                    `https://cortex-site.runasp.net/api/Partners`,
                    { withCredentials: false }
                  );
                  console.log(response.data);
                  setPartners(response.data);
                } catch (error) {
                  console.error("Error fetching products:", error);
                }
              };

  // const newsItems = [
  //   { id: 1, imgSrc: partners1 },
  //   { id: 2, imgSrc: partners2 },
  //   { id: 3, imgSrc: partners3 },
  //   { id: 4, imgSrc: partners4 },
  //   { id: 5, imgSrc: partners5 },
  //   { id: 6, imgSrc: partners6 },
  //   { id: 7, imgSrc: partners7 },
  //   { id: 8, imgSrc: partners8 },
  //   { id: 9, imgSrc: partners9 },
  //   { id: 10, imgSrc: partners10 },
  //   { id: 11, imgSrc: partners11 },
  //   { id: 12, imgSrc: partners12 },
  //   { id: 13, imgSrc: partners13 },
  //   { id: 14, imgSrc: partners14 },
  //   { id: 15, imgSrc: partners15 },
  //   { id: 16, imgSrc: partners16 },
  //   { id: 17, imgSrc: partners17 },
  //   { id: 18, imgSrc: partners18 },
  //   { id: 19, imgSrc: partners19 },
  //   { id: 20, imgSrc: partners20 },
  //   { id: 21, imgSrc: partners21 },
  //   { id: 22, imgSrc: partners22 },
  // ];

  const handleScroll = (direction) => {
    const container = marqueeRef.current;
    if (!container) return;
    const scrollAmount = 200;
    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div className="w-full justify-center items-center relative mt-[56px] md:mt-[88px] flex">
      <div className="md:max-w-container max-w-containerSm flex flex-col mx-auto justify-between relative py-8">
        {/* Başlık ve Butonlar */}
        <div className="flex justify-between items-center h-[50px]">
          <p className="text-[24px] md:text-[32px] font-medium text-[#2a3d63]">
            {t("Tərəfdaşlarımız")}
          </p>

          <div className="absolute top-8 right-0 flex gap-2">
            <button
              onClick={() => handleScroll("left")}
              className="swiper-button-prev-custom border-2 border-[#E5E5E5] group hover:border-[#2a3d63] p-[10px] rounded-lg"
            >
              <i className="fa-solid fa-angle-left w-4 text-[#767676] group-hover:text-[#2a3d63]"></i>
            </button>
            <button
              onClick={() => handleScroll("right")}
              className="swiper-button-next-custom border-2 border-[#E5E5E5] group hover:border-[#2a3d63] p-[10px] rounded-lg"
            >
              <i className="fa-solid fa-angle-right w-4 text-[#767676] group-hover:text-[#2a3d63]"></i>
            </button>
          </div>
        </div>

        {/* Slider */}
        <div className="mt-10 overflow-hidden">
          <div className="marquee-container" ref={marqueeRef}>
            <div className="marquee-content items-center">
              {partners.concat(partners).map((item, index) => (
                <div key={index} className="marquee-item">
                  <img src={`https://cortex-site.runasp.net/${item.image}`} alt={`partner-${index}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brands;
